import * as Types from '@crimeos-frontend/crime-os/graphql'

import { gql } from '@apollo/client'
import {
  SectionFragmentDoc,
  FilterFragmentDoc,
  HandleSectionFragmentDoc
} from '@crimeos-frontend/crime-os/graphql-docs'
import * as Apollo from '@apollo/client'
export type BasicDetailsRecordConfigFragment = {
  __typename: 'BasicDetailsRecordConfig'
  firFieldIds: Array<string>
  petitionFieldIds: Array<string>
  ncrpComplaintFieldIds: Array<string>
}

export type GetComplaintConfigFragment = {
  __typename: 'GetComplaintConfig'
  complaintTemplateId: string
  sendServiceRequestsTo: Types.SendServiceRequestsTo
  firNumberRegex: string
  petitionNumberRegex: string
  acknowledgementNumberRegex: string
  createComplaintConfig?: {
    __typename: 'CreateComplaintConfig'
    supportedYears: Array<number>
    orderedSections: Array<{
      __typename: 'Section'
      sectionId: string
      sectionName: string
      defaultIcon: string
      sectionType: Types.SectionType
      sectionDescription: string
      selectedIcon: string
      recordCreationName?: string | null
      templateSelection?: {
        __typename: 'SectionTemplateSelection'
        placeholder: string
        label: string
      } | null
      noRecordsView: {
        __typename: 'SectionNoRecordsView'
        title: string
        description: string
      }
      filtersConfig: Array<{
        __typename: 'Filter'
        filterId: string
        name: string
        isMultiSelectOption: boolean
        filterOptions: Array<{
          __typename: 'FilterOption'
          name: string
          id: string
        }>
      }>
      orderedSectionTemplates: Array<{
        __typename: 'SectionTemplate'
        canHaveMultipleRecords: boolean
        iconUrl: string
        templateId: string
        previewFields: Array<{
          __typename: 'PreviewField'
          fieldId: string
          hideIfEmpty: boolean
        }>
      }>
    }>
    basicDetailsRecordConfig: {
      __typename: 'BasicDetailsRecordConfig'
      firFieldIds: Array<string>
      petitionFieldIds: Array<string>
      ncrpComplaintFieldIds: Array<string>
    }
  } | null
  viewComplaintConfig?: {
    __typename: 'ViewComplaintConfig'
    orderedSections: Array<{
      __typename: 'Section'
      sectionId: string
      sectionName: string
      defaultIcon: string
      sectionType: Types.SectionType
      sectionDescription: string
      selectedIcon: string
      recordCreationName?: string | null
      templateSelection?: {
        __typename: 'SectionTemplateSelection'
        placeholder: string
        label: string
      } | null
      noRecordsView: {
        __typename: 'SectionNoRecordsView'
        title: string
        description: string
      }
      filtersConfig: Array<{
        __typename: 'Filter'
        filterId: string
        name: string
        isMultiSelectOption: boolean
        filterOptions: Array<{
          __typename: 'FilterOption'
          name: string
          id: string
        }>
      }>
      orderedSectionTemplates: Array<{
        __typename: 'SectionTemplate'
        canHaveMultipleRecords: boolean
        iconUrl: string
        templateId: string
        previewFields: Array<{
          __typename: 'PreviewField'
          fieldId: string
          hideIfEmpty: boolean
        }>
      }>
    }>
    basicDetailsRecordConfig: {
      __typename: 'BasicDetailsRecordConfig'
      firFieldIds: Array<string>
      petitionFieldIds: Array<string>
      ncrpComplaintFieldIds: Array<string>
    }
    handleSections: Array<{
      __typename: 'HandleSection'
      sectionId: string
      name: string
      description: string
      sectionType: Types.HandleSectionTypeEnum
      defaultIconUrl: string
      selectedIconUrl: string
      supportedTemplateIds: Array<string>
    }>
  } | null
  complaintsTableConfig?: {
    __typename: 'ListComplaintsTableConfig'
    orderedColumns: Array<{ __typename: 'ColumnConfig'; fieldId: string }>
    filtersConfig: Array<{
      __typename: 'Filter'
      filterId: string
      name: string
      isMultiSelectOption: boolean
      filterOptions: Array<{
        __typename: 'FilterOption'
        name: string
        id: string
      }>
    }>
  } | null
  refundWorkflowConfig?: {
    __typename: 'RefundWorkflowConfig'
    workFlowStages: Array<{
      __typename: 'RefundWorkFlowStage'
      description: string
      displayName: string
      stageStatus: Types.RefundStatusEnum
      templateId: string
    }>
  } | null
  deFreezeWorkflowConfig?: {
    __typename: 'DeFreezeWorkflowConfig'
    workFlowStages: Array<{
      __typename: 'DeFreezeWorkFlowStage'
      description: string
      displayName: string
      stageStatus: Types.DeFreezeStatusEnum
      templateId: string
    }>
  } | null
  templateFieldsConfigs: Array<{
    __typename: 'TemplateServiceRequestFieldsConfig'
    templateId: string
    fieldsConfig: string
  }>
}

export type GetComplaintConfigQueryVariables = Types.Exact<{
  [key: string]: never
}>

export type GetComplaintConfigQuery = {
  __typename: 'Query'
  getComplaintConfig: {
    __typename: 'GetComplaintConfig'
    complaintTemplateId: string
    sendServiceRequestsTo: Types.SendServiceRequestsTo
    firNumberRegex: string
    petitionNumberRegex: string
    acknowledgementNumberRegex: string
    createComplaintConfig?: {
      __typename: 'CreateComplaintConfig'
      supportedYears: Array<number>
      orderedSections: Array<{
        __typename: 'Section'
        sectionId: string
        sectionName: string
        defaultIcon: string
        sectionType: Types.SectionType
        sectionDescription: string
        selectedIcon: string
        recordCreationName?: string | null
        templateSelection?: {
          __typename: 'SectionTemplateSelection'
          placeholder: string
          label: string
        } | null
        noRecordsView: {
          __typename: 'SectionNoRecordsView'
          title: string
          description: string
        }
        filtersConfig: Array<{
          __typename: 'Filter'
          filterId: string
          name: string
          isMultiSelectOption: boolean
          filterOptions: Array<{
            __typename: 'FilterOption'
            name: string
            id: string
          }>
        }>
        orderedSectionTemplates: Array<{
          __typename: 'SectionTemplate'
          canHaveMultipleRecords: boolean
          iconUrl: string
          templateId: string
          previewFields: Array<{
            __typename: 'PreviewField'
            fieldId: string
            hideIfEmpty: boolean
          }>
        }>
      }>
      basicDetailsRecordConfig: {
        __typename: 'BasicDetailsRecordConfig'
        firFieldIds: Array<string>
        petitionFieldIds: Array<string>
        ncrpComplaintFieldIds: Array<string>
      }
    } | null
    viewComplaintConfig?: {
      __typename: 'ViewComplaintConfig'
      orderedSections: Array<{
        __typename: 'Section'
        sectionId: string
        sectionName: string
        defaultIcon: string
        sectionType: Types.SectionType
        sectionDescription: string
        selectedIcon: string
        recordCreationName?: string | null
        templateSelection?: {
          __typename: 'SectionTemplateSelection'
          placeholder: string
          label: string
        } | null
        noRecordsView: {
          __typename: 'SectionNoRecordsView'
          title: string
          description: string
        }
        filtersConfig: Array<{
          __typename: 'Filter'
          filterId: string
          name: string
          isMultiSelectOption: boolean
          filterOptions: Array<{
            __typename: 'FilterOption'
            name: string
            id: string
          }>
        }>
        orderedSectionTemplates: Array<{
          __typename: 'SectionTemplate'
          canHaveMultipleRecords: boolean
          iconUrl: string
          templateId: string
          previewFields: Array<{
            __typename: 'PreviewField'
            fieldId: string
            hideIfEmpty: boolean
          }>
        }>
      }>
      basicDetailsRecordConfig: {
        __typename: 'BasicDetailsRecordConfig'
        firFieldIds: Array<string>
        petitionFieldIds: Array<string>
        ncrpComplaintFieldIds: Array<string>
      }
      handleSections: Array<{
        __typename: 'HandleSection'
        sectionId: string
        name: string
        description: string
        sectionType: Types.HandleSectionTypeEnum
        defaultIconUrl: string
        selectedIconUrl: string
        supportedTemplateIds: Array<string>
      }>
    } | null
    complaintsTableConfig?: {
      __typename: 'ListComplaintsTableConfig'
      orderedColumns: Array<{ __typename: 'ColumnConfig'; fieldId: string }>
      filtersConfig: Array<{
        __typename: 'Filter'
        filterId: string
        name: string
        isMultiSelectOption: boolean
        filterOptions: Array<{
          __typename: 'FilterOption'
          name: string
          id: string
        }>
      }>
    } | null
    refundWorkflowConfig?: {
      __typename: 'RefundWorkflowConfig'
      workFlowStages: Array<{
        __typename: 'RefundWorkFlowStage'
        description: string
        displayName: string
        stageStatus: Types.RefundStatusEnum
        templateId: string
      }>
    } | null
    deFreezeWorkflowConfig?: {
      __typename: 'DeFreezeWorkflowConfig'
      workFlowStages: Array<{
        __typename: 'DeFreezeWorkFlowStage'
        description: string
        displayName: string
        stageStatus: Types.DeFreezeStatusEnum
        templateId: string
      }>
    } | null
    templateFieldsConfigs: Array<{
      __typename: 'TemplateServiceRequestFieldsConfig'
      templateId: string
      fieldsConfig: string
    }>
  }
}

export const BasicDetailsRecordConfigFragmentDoc = gql`
  fragment BasicDetailsRecordConfig on BasicDetailsRecordConfig {
    firFieldIds
    petitionFieldIds
    ncrpComplaintFieldIds
  }
`
export const GetComplaintConfigFragmentDoc = gql`
  fragment GetComplaintConfig on GetComplaintConfig {
    createComplaintConfig {
      orderedSections {
        ...Section
      }
      supportedYears
      basicDetailsRecordConfig {
        ...BasicDetailsRecordConfig
      }
    }
    viewComplaintConfig {
      orderedSections {
        ...Section
      }
      basicDetailsRecordConfig {
        ...BasicDetailsRecordConfig
      }
      handleSections {
        ...HandleSection
      }
    }
    complaintsTableConfig {
      orderedColumns {
        fieldId
      }
      filtersConfig {
        ...Filter
      }
    }
    complaintTemplateId
    sendServiceRequestsTo
    refundWorkflowConfig {
      workFlowStages {
        description
        displayName
        stageStatus
        templateId
      }
    }
    deFreezeWorkflowConfig {
      workFlowStages {
        description
        displayName
        stageStatus
        templateId
      }
    }
    templateFieldsConfigs {
      templateId
      fieldsConfig
    }
    firNumberRegex
    petitionNumberRegex
    acknowledgementNumberRegex
  }
  ${SectionFragmentDoc}
  ${BasicDetailsRecordConfigFragmentDoc}
  ${HandleSectionFragmentDoc}
  ${FilterFragmentDoc}
`
export const GetComplaintConfigDocument = gql`
  query GetComplaintConfig {
    getComplaintConfig {
      ... on GetComplaintConfig {
        ...GetComplaintConfig
      }
    }
  }
  ${GetComplaintConfigFragmentDoc}
`
export type GetComplaintConfigQueryResult = Apollo.QueryResult<
  GetComplaintConfigQuery,
  GetComplaintConfigQueryVariables
>
